function resetProductPage() {
    $("input.message-input-wrapper").each(function() {
        this.value = '';
        $(this).hide();
    });

    $("input.card-message").each(function() {
        this.value = '';
    });

    $(".upsell-checkbox input").each(function() {
        this.checked = false;
        upsellProducts = [];
    });

    $("#upsellTimeStamp").val($.now());
    $("#itemTimestamp").val($.now());

    $("quantity-selector.quantity-selector").show();

    //document.dispatchEvent(new CustomEvent("cart:refresh"));
    //window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate);
    location.reload();
}

async function checkForUpsellProducts() {

    if(document.getElementById('upsellTimeStamp')) {
        var formData = {items: []}
        var timestamp = document.getElementById('upsellTimeStamp').value;
        for (let i = 0; i < upsellProducts.length; i++) {
            formData.items.push({
                'id': upsellProducts[i],
                'quantity': 1,
                'properties': {
                    '_timestamp': timestamp,
                    '_upsell': "true",
                    '_child': "true"
                }
            });

        }
        formData['sections'] = "cart-items, cart-drawer";
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/javascript'
            },
            body: JSON.stringify(formData)
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    return;
                }
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: {
                        addToCartBtn: this.addToCartButton
                    },
                    bubbles: true
                }));

                resetProductPage();

            })
            .catch((e) => {
                console.error(e);
                document.getElementById('stringConfigErrorMessage').innerHTML = document.getElementById('stringConfigError').getAttribute("data-message");
                document.getElementById('stringConfigError').classList.add('active');
            });

    }
}
